import { extractUserSet } from "../api";
import { SqlDataTable } from "../components/SqlDataTable";
import { SqlPieChart } from "../components/SqlPieChart";
import { openExportUsersModal } from "@/components/elements/ExportUsersModal";

interface Data { name: string, value: number };

const dataQuery = `
  select
    (select title from articles where id = data.article_id) as name,
    data.value,
    data.article_id,
  from (
    select article_id, count(*) as value
    from events where type = 'event' and article_id is not null
    and label = 'start-subscribe'
    and epoch_ms(ts) > (now() - INTERVAL 7 DAY)
    group by article_id
  ) data
  order by value desc
`;

const extractUsersQuery = `
  select user_id
  from events where type = 'event'
  and label = 'start-subscribe'
  and article_id = ?
  and epoch_ms(ts) > (now() - INTERVAL 7 DAY)
`

export function ArticleStartSubscribeChart() {
  return <SqlDataTable
    label="Subscribe Starter Articles"
    subtext="Articles triggering users to start the subscribe flow. (NOTE: Incomplete data. User export will not work.) (Last 7 days)"
    width={900}
    onClick={(data: Data) => {
      let users: Set<string>;
      openExportUsersModal({
        headerContent: <>
          Includes only users who started the subscribe flow after visiting <b>{data.name}</b>.
        </>,
        onDownload: async () => {
          users = await extractUserSet(extractUsersQuery, [data.name])
        },
        beforeCsv: async (exportUsers) => {
          return exportUsers.filter(u => users.has(u.id));
        }
      })
    }}
  >{dataQuery}</SqlDataTable>
}